import styled from 'styled-components'

export const LabelsWrapper = styled.div<{ $mt: number }>`
  display: flex;
  justify-content: space-between;
  margin-top: ${({ $mt }) => $mt}px;
  gap: 12px;
`

export const TrustItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  flex: 1 0;
  background-color: rgba(34, 197, 94, 0.08);
  border-radius: 8px;
  padding: 6px 8px;
  font-weight: 700;
  font-size: 10px;
  color: #15803d;
`
